import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Company Details")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-3" }
const _hoisted_4 = { class: "mb-10" }
const _hoisted_5 = { class: "d-flex flex-wrap py-5" }
const _hoisted_6 = { class: "flex-equal me-5" }
const _hoisted_7 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400 min-w-175px w-175px" }, "Company Name", -1)
const _hoisted_9 = { class: "text-gray-800 min-w-200px" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "First Name:", -1)
const _hoisted_11 = { class: "text-gray-800" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Last Name:", -1)
const _hoisted_13 = { class: "text-gray-800" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Email:", -1)
const _hoisted_15 = { class: "text-gray-800" }
const _hoisted_16 = { class: "flex-equal" }
const _hoisted_17 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400 min-w-175px w-175px" }, "Date Joined:", -1)
const _hoisted_19 = { class: "text-gray-800 min-w-200px" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Plan:", -1)
const _hoisted_21 = { class: "text-gray-800" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Last Login:", -1)
const _hoisted_23 = { class: "text-gray-800" }
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "card-header border-0 pt-6" }
const _hoisted_26 = { class: "card-title" }
const _hoisted_27 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_28 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_29 = {
  key: 0,
  class: "card-body pt-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: { name: 'admin-subscriptions' },
                      class: "text-gray-800 text-hover-primary px-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.company.company_name), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.company.first_name), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.company.last_name), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.company.email), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("table", _hoisted_17, [
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.company.date_joined), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.company.plan), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_22,
                  _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.company.last_login), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Users"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ])
      ]),
      (_ctx.tableData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": true
            }, {
              "cell-email": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.email), 1)
              ]),
              "cell-first_name": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.first_name), 1)
              ]),
              "cell-last_name": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.last_name), 1)
              ]),
              "cell-date_joined": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(customer.date_joined)), 1)
              ]),
              _: 1
            }, 8, ["table-data", "table-header"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}